<template>
  <div class="light-linear-pro">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$h'/h = v/u$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区域 -->
      <div class="simulation-stage dark-stage">
        <svg width="100%" height="220" viewBox="0 0 500 220">
           <!-- 地面/参考线 -->
           <line x1="0" y1="180" x2="500" y2="180" stroke="rgba(255,255,255,0.1)" stroke-width="1" />
           
           <!-- 蜡烛 (光源) -->
           <g transform="translate(60, 100)">
              <rect x="-6" y="20" width="12" height="60" fill="#f8fafc" rx="2" />
              <path d="M -6 20 Q 0 -5 6 20" fill="#ef4444">
                 <animate attributeName="d" values="M -6 20 Q 0 -5 6 20; M -6 20 Q 3 -3 6 20; M -6 20 Q 0 -5 6 20" dur="0.6s" repeatCount="indefinite" />
              </path>
              <text x="0" y="95" text-anchor="middle" fill="#94a3b8" font-size="10" font-weight="700">物体 (S)</text>
           </g>

           <!-- 小孔档板 -->
           <rect :x="248 + pinholeX" y="30" width="4" height="150" fill="#1e293b" rx="2" stroke="#334155" />
           <circle :cx="250 + pinholeX" cy="110" r="3.5" fill="#000" stroke="#475569" stroke-width="1" />
           <text :x="250 + pinholeX" y="22" text-anchor="middle" fill="#94a3b8" font-size="10">小孔</text>
           
           <!-- 光路追踪 -->
           <g opacity="0.4">
              <line x1="60" y1="100" :x2="440" :y2="110 + (110 - 100) * (180 / (190 + pinholeX))" stroke="#f59e0b" stroke-width="1" stroke-dasharray="4,2" />
              <line x1="60" y1="180" :x2="440" :y2="110 + (110 - 180) * (180 / (190 + pinholeX))" stroke="#f59e0b" stroke-width="1" stroke-dasharray="4,2" />
           </g>

           <!-- 成像屏幕 -->
           <rect x="440" y="30" width="4" height="150" fill="#334155" rx="1" />
           
           <!-- 倒立的像 - 保持文字不反转 -->
           <g :transform="`translate(440, 110)`">
              <!-- 仅缩放几何体 -->
              <g :transform="`scale(${-magnification})`">
                 <rect x="-8" y="-80" width="8" height="80" fill="rgba(255,255,255,0.3)" />
                 <path d="M -8 -80 Q 0 -105 8 -80" fill="rgba(239, 68, 68, 0.4)" />
              </g>
              <text x="10" y="80" text-anchor="start" fill="#10b981" font-size="10" font-weight="700">倒立实像 (S')</text>
           </g>
        </svg>

        <div class="hud-panel">
           <div class="hud-item cyan">
              <label>放大倍率 (M)</label>
              <span class="val">{{ magnification.toFixed(2) }} x</span>
           </div>
        </div>
      </div>

      <!-- 参数控制 -->
      <div class="compact-controls">
        <div class="control-card">
           <div class="s-item">
              <label>调节档板位置 (改变位移 u & v)</label>
              <el-slider v-model="pinholeX" :min="-120" :max="120" size="small"></el-slider>
           </div>
        </div>

        <div class="discovery-card-compact" v-latex>
           <i class="el-icon-info"></i>
           <p><strong>物理规律：</strong>光在同种均匀介质中沿<strong>直线传播</strong>。小孔成像成倒立实像，像的大小由像距与物距之比决定。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LightLinearViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() { return { pinholeX: 0 } },
  computed: {
    magnification() {
      const u = 190 + this.pinholeX;
      const v = 190 - this.pinholeX;
      return v / u;
    }
  }
}
</script>

<style scoped lang="scss">
.light-linear-pro { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
.viz-header-compact { display: flex; justify-content: space-between; align-items: center; padding: 0 4px; .brief { font-size: 13px; color: #1e293b; font-weight: 500; } .formula-chip { background: #f0f7ff; color: #2563eb; border: 1px solid #dbeafe; padding: 4px 14px; border-radius: 20px; font-weight: 700; font-family: monospace; } }
.simulation-stage { flex: 1; min-height: 220px; background: #020617; border-radius: 12px; border: 1.5px solid #1e293b; position: relative; overflow: hidden; .hud-panel { position: absolute; top: 12px; left: 12px; z-index: 10; .hud-item { background: rgba(15, 23, 42, 0.8); border-radius: 8px; border: 1px solid #1e293b; padding: 4px 12px; label { display: block; font-size: 10px; color: #64748b; font-weight: 700; } .val { font-size: 14px; color: #22d3ee; font-weight: 800; } &.cyan { border-left: 3px solid #06b6d4; } } } }
.compact-controls { display: flex; flex-direction: column; gap: 8px; }
.control-card { background: #ffffff; padding: 12px 16px; border-radius: 12px; border: 1px solid #e2e8f0; }
.s-item { label { font-size: 11px; color: #64748b; font-weight: 700; display: block; margin-bottom: 2px; } }
.discovery-card-compact { background: #f0f9ff; padding: 10px 14px; border-radius: 10px; border: 1px solid #e0f2fe; display: flex; align-items: center; gap: 10px; i { color: #0ea5e9; font-size: 1.1rem; } p { flex: 1; margin: 0; font-size: 12px; color: #0369a1; line-height: 1.5; strong { color: #075985; } } }
</style>
